import { render, staticRenderFns } from "./SocialItem.vue?vue&type=template&id=37c66c97"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"
import style0 from "./SocialItem.vue?vue&type=style&index=0&id=37c66c97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports